// context/CartContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import SummaryApi from '../common';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);
  const [cartItems, setCartItems] = useState([]);

  // Fetch cart count on initial load
  useEffect(() => {
    fetchCartCount();
  }, []);

  const fetchCartCount = async () => {
    try {
      const customerId = sessionStorage.getItem('customer_id');
      if (!customerId) return;

      const response = await fetch(SummaryApi.getCartCount.url, {
        method: SummaryApi.getCartCount.method,
        headers: {
          'Authorization': SummaryApi.bearerToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customer_id: customerId
        })
      });

      const data = await response.json();
      if (data.status) {
        setCartCount(data.count || 0);
      }
    } catch (error) {
      console.error('Error fetching cart count:', error);
    }
  };

  const addToCart = async (productId, quantity = 1) => {
    try {
      const customerId = sessionStorage.getItem('customer_id');
      if (!customerId) {
        alert('Please login to add items to cart');
        return { success: false, message: 'Please login first' };
      }

      const response = await fetch(SummaryApi.addToCart.url, {
        method: SummaryApi.addToCart.method,
        headers: {
          'Authorization': SummaryApi.bearerToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customer_id: customerId,
          product_id: productId,
          quantity: quantity
          // cart_id is optional, backend will handle it
        })
      });

      const data = await response.json();
      
      if (data.status) {
        // Update cart count
        await fetchCartCount();
        return { success: true, message: data.message };
      } else {
        return { success: false, message: data.message || 'Failed to add to cart' };
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      return { success: false, message: 'Network error' };
    }
  };

  const updateCartCount = (count) => {
    setCartCount(count);
  };

  const clearCart = () => {
    setCartCount(0);
    setCartItems([]);
  };

  return (
    <CartContext.Provider value={{
      cartCount,
      cartItems,
      addToCart,
      fetchCartCount,
      updateCartCount,
      clearCart
    }}>
      {children}
    </CartContext.Provider>
  );
};